import { Divider, Field, Spinner, Text, makeStyles, tokens } from '@fluentui/react-components';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getApiLicensingCurrentOptions, getApiLicensingVersionOptions } from '../../api/@tanstack/react-query.gen';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXXL,
  },
  versionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    paddingTop: tokens.spacingVerticalXXL,
  },
  versionDivider: {
    paddingTop: tokens.spacingVerticalXXL,
  },
});

export default function LicenseInfo() {
  const styles = useStyles();
  const { data, error, isLoading } = useQuery(getApiLicensingCurrentOptions());
  const { data: backendVersion } = useQuery(getApiLicensingVersionOptions());
  const { t } = useTranslation();
  const frontendVersion = import.meta.env.VITE_APP_VERSION;

  const formatData = [
    {
      key: t('license.dialog.client'),
      value: data?.client,
    },
    {
      key: t('license.dialog.type'),
      value: data?.subscriptionType,
    },
    {
      key: t('license.dialog.expiry'),
      value: new Date(data?.expiry ?? '').toLocaleString(),
    },
    {
      key: t('license.dialog.productGuid'),
      value: data?.productGuid,
    },
    {
      key: t('license.dialog.domains'),
      value: data?.domains?.join(', '),
    },
  ];

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <Text>{error.message}</Text>;
  }

  return (
    <>
      <Divider />
      <div className={styles.container}>
        {formatData.map((item) => (
          <Field key={item.key} label={item.key}>
            <Text>{item.value}</Text>
          </Field>
        ))}
      </div>
      {/* TODO: besseren Ort für die Versionsanzeige finden */}
      <Divider className={styles.versionDivider} />
      <div className={styles.versionContainer}>
        <Text>UI: {frontendVersion}</Text>
        <Text>API: {backendVersion}</Text>
      </div>
    </>
  );
}
